<template>
  <div class="dashboard-container tagihan">
    <div v-if="memuat" class="tagihan__pesan">
      <span class="spinner-border"></span> Memuat tagihan...
    </div>

    <template v-else-if="tagihan.id">
      <!-- ── Kepala ── -->
      <div class="tagihan__kepala">
        <div class="d-flex align-items-center gap-3">
          <img
            v-if="tagihan.tournament?.logo_url"
            :src="tagihan.tournament.logo_url"
            alt="Logo Event"
            class="tagihan__logo-event shadow-sm"
          />
          <div>
            <span class="tagihan__nomor">{{ tagihan.invoice_number }}</span>
            <h1 class="tagihan__judul">{{ tagihan.tournament?.name || 'Tagihan' }}</h1>
          </div>
        </div>

        <div class="d-flex align-items-center gap-2 flex-wrap">
          <button type="button" class="button button-ghost d-flex align-items-center gap-1"
                  :disabled="mengunduhInvoice" @click="unduhInvoice">
            <i class="bi" :class="mengunduhInvoice ? 'bi-arrow-repeat berputar' : 'bi-file-earmark-pdf'"></i>
            <span>{{ mengunduhInvoice ? 'Mengunduh...' : 'Unduh Invoice' }}</span>
          </button>

          <button v-if="tagihan.status === 'paid'" type="button" class="button button-secondary d-flex align-items-center gap-1"
                  :disabled="mengunduhKwitansi" @click="unduhKwitansi">
            <i class="bi" :class="mengunduhKwitansi ? 'bi-arrow-repeat berputar' : 'bi-patch-check-fill text-success'"></i>
            <span>{{ mengunduhKwitansi ? 'Mengunduh...' : 'Unduh Kwitansi' }}</span>
          </button>

          <button v-if="dapatDihapus" type="button" class="button button-danger d-flex align-items-center gap-1"
                  :disabled="menghapus" @click="hapusTagihan">
            <i class="bi" :class="menghapus ? 'bi-arrow-repeat berputar' : 'bi-trash3'"></i>
            <span>{{ menghapus ? 'Menghapus...' : 'Hapus Tagihan' }}</span>
          </button>

          <span class="lencana" :class="`lencana--${status.warna}`">
            <i :class="status.ikon"></i> {{ status.label }}
          </span>
        </div>
      </div>

      <!-- ── Langkah ── -->
      <ol class="langkah">
        <li v-for="(l, i) in langkah" :key="i" class="langkah__butir"
            :class="{ 'langkah__butir--lewat': i <= indeksLangkah }">
          <span class="langkah__angka">{{ i + 1 }}</span>
          <span class="langkah__teks">{{ l }}</span>
        </li>
      </ol>

      <div class="tagihan__isi">
        <!-- ── Atlet ── -->
        <section class="tagihan__blok">
          <h2 class="tagihan__subjudul">
            Atlet yang ditagihkan
            <span class="tagihan__hitung">{{ rincian.length }}</span>
          </h2>

          <ul class="rincian">
            <li v-for="d in rincian" :key="d.id" class="rincian__baris">
              <div>
                <span class="rincian__nama fw-semibold d-block">
                  {{ d.name || d.team_member?.name || d.teamMember?.name || d.tim_seni?.name || d.timSeni?.name || '—' }}
                </span>
                <small class="text-muted d-block" style="font-size: 0.78rem; margin-top: 2px;">
                  <span v-if="d.match_category?.name || d.matchCategory?.name">{{ gantiTingkatDiNama(d.match_category?.name || d.matchCategory?.name, tagihan.tournament) }}</span>
                  <span v-if="d.category_class?.name || d.categoryClass?.name"> ({{ d.category_class?.name || d.categoryClass?.name }})</span>
                  <span v-if="(d.match_category || d.matchCategory) && (d.age_category || d.ageCategory)"> • </span>
                  <span v-if="d.age_category?.name || d.ageCategory?.name">{{ d.age_category?.name || d.ageCategory?.name }}</span>
                  <span v-if="d.contingent?.name" class="text-secondary"> ({{ d.contingent.name }})</span>
                </small>
              </div>
              <span class="rincian__biaya fw-bold">{{ rupiah(d.amount) }}</span>
            </li>
          </ul>

          <div class="rincian__total">
            <span>Total</span>
            <strong>{{ rupiah(tagihan.amount) }}</strong>
          </div>
        </section>

        <!-- ── Pembayaran ── -->
        <section class="tagihan__blok">
          <h2 class="tagihan__subjudul">Kirim pembayaran ke</h2>

          <div v-if="tagihan.account_number && tagihan.account_number !== '-'" class="rekening">
            <div class="rekening__baris">
              <small>Bank</small><span>{{ tagihan.bank_name }}</span>
            </div>
            <div class="rekening__baris">
              <small>Nomor rekening</small>
              <span class="rekening__nomor">
                {{ tagihan.account_number }}
                <button type="button" class="rekening__salin" @click="salin(tagihan.account_number)">
                  <i class="bi bi-clipboard"></i> Salin
                </button>
              </span>
            </div>
            <div class="rekening__baris">
              <small>Atas nama</small><span>{{ tagihan.account_name }}</span>
            </div>
          </div>

          <p v-else class="tagihan__catatan">
            <i class="bi bi-exclamation-triangle"></i>
            Panitia belum mencantumkan rekening tujuan. Hubungi bendahara acara
            untuk mengetahui ke mana pembayaran dikirim.
          </p>

          <!-- Unggah bukti -->
          <div v-if="bolehUnggah" class="bukti">
            <h3 class="tagihan__subjudul tagihan__subjudul--kecil">Bukti transfer</h3>

            <img v-if="tagihan.payment_document" :src="tagihan.payment_document"
                 alt="Bukti transfer" class="bukti__gambar" />

            <label class="bukti__pilih">
              <input type="file" accept="image/*" class="bukti__input" @change="pilihBerkas" />
              <i class="bi bi-upload"></i>
              {{ tagihan.payment_document ? 'Ganti bukti transfer' : 'Unggah bukti transfer' }}
            </label>

            <p v-if="namaBerkas" class="bukti__nama">{{ namaBerkas }}</p>

            <button type="button" class="button button-primary bukti__kirim"
                    :disabled="!berkas || mengunggah" @click="unggah">
              <i class="bi" :class="mengunggah ? 'bi-arrow-repeat berputar' : 'bi-send'"></i>
              {{ mengunggah ? 'Mengirim...' : 'Kirim bukti ke bendahara' }}
            </button>

            <!--
              Kalimat ini penting: setelah bukti dikirim, TIDAK ada yang
              berubah otomatis. Tanpa penjelasan ini pelatih akan menunggu
              status berubah sendiri dan mengira sistemnya rusak.
            -->
            <p class="bukti__keterangan">
              <i class="bi bi-info-circle"></i>
              Setelah bukti dikirim, bendahara acara akan memeriksanya secara
              manual. Status atlet berubah menjadi lunas setelah bendahara
              menyetujuinya — biasanya dalam 1×24 jam pada hari kerja.
            </p>
          </div>

          <div v-else-if="tagihan.status === 'paid'" class="tagihan__lunas-area">
            <p class="tagihan__lunas">
              <i class="bi bi-patch-check-fill"></i>
              Pembayaran sudah disetujui bendahara. Seluruh atlet pada tagihan ini
              berstatus lunas.
            </p>
            <button type="button" class="button button-primary w-100 mt-2 d-flex align-items-center justify-content-center gap-2"
                    :disabled="mengunduhKwitansi" @click="unduhKwitansi">
              <i class="bi" :class="mengunduhKwitansi ? 'bi-arrow-repeat berputar' : 'bi-file-earmark-check-fill'"></i>
              <span>{{ mengunduhKwitansi ? 'Sedang Mengunduh Kwitansi...' : 'Unduh Kwitansi Pembayaran Resmi (PDF)' }}</span>
            </button>
          </div>
        </section>
      </div>

      <!-- ── Bendahara ── -->
      <section v-if="bolehVerifikasi" class="tagihan__blok tagihan__blok--panitia">
        <h2 class="tagihan__subjudul">Tindakan bendahara</h2>
        <p class="tagihan__catatan-kecil">
          Periksa bukti transfer terhadap mutasi rekening sebelum menyetujui.
        </p>

        <div class="ui-field tagihan__alasan">
          <label class="ui-label" for="alasan-tolak">
            Alasan penolakan <span class="ui-label__hint">(wajib bila menolak, dikirim ke pelatih)</span>
          </label>
          <textarea id="alasan-tolak" ref="alasanTolak" v-model.trim="alasanTolak" class="ui-textarea" rows="2" maxlength="255"
                    placeholder="Contoh: nominal transfer kurang Rp 50.000"></textarea>
        </div>

        <div class="tagihan__aksi">
          <button type="button" class="button button-secondary" :disabled="memproses"
                  @click="putuskan('paid')">
            <i class="bi bi-check2-circle"></i> Setujui — tandai lunas
          </button>
          <button type="button" class="button button-danger" :disabled="memproses"
                  @click="putuskan('failed')">
            <i class="bi bi-x-circle"></i> Tolak
          </button>
        </div>

        <div v-if="tagihan.reject_reason" class="tagihan__catatan">
          <i class="bi bi-chat-left-text"></i>
          <span>Alasan penolakan sebelumnya: {{ tagihan.reject_reason }}</span>
        </div>
      </section>
    </template>

    <p v-else class="tagihan__pesan">Tagihan tidak ditemukan.</p>
  </div>
</template>

<script>
import { gantiTingkatDiNama } from '@/utils/tingkat';
import { inject } from 'vue';
import { useToast } from 'vue-toastification';
import { useConfirm } from '@/composables/useConfirm';
import { setActiveEvent } from '@/utils/eventTheme';
import http from '@/services/http';

/*
| Status disimpan dalam bahasa Inggris di basis data (nilai enum yang sudah
| dipakai data lama). Diterjemahkan di sini, bukan diubah di basis data,
| supaya migrasi tidak perlu menyentuh baris yang sudah ada.
*/
const STATUS = {
  'waiting for payment':      { label: 'Menunggu Pembayaran', warna: 'kuning', ikon: 'bi bi-hourglass-split' },
  'waiting for confirmation': { label: 'Menunggu Verifikasi',  warna: 'biru',   ikon: 'bi bi-clock-history' },
  paid:                       { label: 'Lunas',               warna: 'hijau',  ikon: 'bi bi-patch-check' },
  failed:                     { label: 'Ditolak',             warna: 'merah',  ikon: 'bi bi-x-circle' },
  cancelled:                  { label: 'Dibatalkan',          warna: 'netral', ikon: 'bi bi-slash-circle' },
};

export default {
  name: 'TagihanDetailPage',

  setup() {
    return {
      toast: useToast(),
      konfirmasi: useConfirm().konfirmasi,
      permissions: inject('permissions', []),
    };
  },

  data() {
    return {
      tagihan: {},
      memuat: false,
      berkas: null,
      namaBerkas: '',
      mengunggah: false,
      memproses: false,
      alasanTolak: '',
      menghapus: false,
      mengunduhInvoice: false,
      mengunduhKwitansi: false,
      langkah: [
        'Pilih atlet dan buat tagihan',
        'Transfer sesuai nominal',
        'Kirim bukti transfer',
        'Bendahara menyetujui — atlet jadi lunas',
      ],
    };
  },

  computed: {
    dapatDihapus() {
      if (!this.tagihan?.id) return false;
      // Bendahara hanya membaca dan menyetujui; server juga menolaknya.
      if (this.userGroup === 'Bendahara') return false;
      const isPanitia = ['Owner', 'Admin', 'Event PIC'].includes(this.userGroup);
      if (isPanitia) return true;
      return this.tagihan.status !== 'paid';
    },

    userGroup() {
      try {
        const u = JSON.parse(localStorage.getItem('user') || '{}');
        return u.group?.name || '';
      } catch (e) {
        return '';
      }
    },

    status() {
      return STATUS[this.tagihan.status] || { label: this.tagihan.status || '—', warna: 'netral', ikon: 'bi bi-question-circle' };
    },

    rincian() {
      return this.tagihan.billing_details || this.tagihan.billingDetails || [];
    },

    indeksLangkah() {
      return {
        'waiting for payment': 1,
        'waiting for confirmation': 2,
        paid: 3,
      }[this.tagihan.status] ?? 0;
    },

    bolehUnggah() {
      if (this.userGroup === 'Bendahara') return false;
      return ['waiting for payment', 'waiting for confirmation', 'failed'].includes(this.tagihan.status);
    },

    bolehVerifikasi() {
      const izin = this.permissions?.value ?? this.permissions;
      return Array.isArray(izin)
        && izin.includes('confirm payment')
        && this.tagihan.status === 'waiting for confirmation';
    },
  },

  mounted() {
    this.muat();
  },

  methods: {
    gantiTingkatDiNama,
    rupiah(n) {
      return new Intl.NumberFormat('id-ID', {
        style: 'currency', currency: 'IDR', minimumFractionDigits: 0,
      }).format(Number(n || 0));
    },

    async muat() {
      this.memuat = true;
      try {
        const { data } = await http.get(`/billings/${this.$route.params.id}`);
        this.tagihan = data?.data || data || {};
        if (this.tagihan.tournament) {
          setActiveEvent(this.tagihan.tournament);
        }
      } catch (e) {
        this.tagihan = {};
        this.toast.error('Gagal memuat tagihan.');
      } finally {
        this.memuat = false;
      }
    },

    async salin(teks) {
      try {
        await navigator.clipboard.writeText(String(teks).replace(/\s/g, ''));
        this.toast.success('Nomor rekening disalin.');
      } catch (e) {
        // Clipboard diblokir di halaman non-HTTPS pada sebagian peramban.
        this.toast.info('Peramban menolak menyalin. Silakan salin manual.');
      }
    },

    async kompresGambar(file, maxLebar = 1400, kualitas = 0.8) {
      if (!file || !file.type.startsWith('image/')) return file;
      if (file.size < 300 * 1024) return file; // jika sudah kecil di bawah 300 KB, tidak perlu dikompres

      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.onload = () => {
            let w = img.width;
            let h = img.height;
            if (w > maxLebar || h > maxLebar) {
              if (w > h) {
                h = Math.round((h * maxLebar) / w);
                w = maxLebar;
              } else {
                w = Math.round((w * maxLebar) / h);
                h = maxLebar;
              }
            }

            const canvas = document.createElement('canvas');
            canvas.width = w;
            canvas.height = h;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, w, h);

            canvas.toBlob(
              (blob) => {
                if (blob && blob.size < file.size) {
                  const hasil = new File([blob], file.name.replace(/\.[^/.]+$/, '') + '.jpg', {
                    type: 'image/jpeg',
                    lastModified: Date.now(),
                  });
                  resolve(hasil);
                } else {
                  resolve(file);
                }
              },
              'image/jpeg',
              kualitas
            );
          };
          img.onerror = () => resolve(file);
          img.src = e.target.result;
        };
        reader.onerror = () => resolve(file);
        reader.readAsDataURL(file);
      });
    },

    async pilihBerkas(ev) {
      const f = ev.target.files?.[0];
      if (!f) return;

      // Kompres foto secara instan di peramban agar proses unggah secepat kilat
      const fileSiap = await this.kompresGambar(f);

      this.berkas = fileSiap;
      this.namaBerkas = fileSiap.name;
    },

    async unggah() {
      if (!this.berkas) return;
      this.mengunggah = true;
      try {
        const bentuk = new FormData();
        bentuk.append('payment_document', this.berkas);

        await http.post(`/billings/${this.tagihan.id}/update-document`, bentuk, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });

        this.berkas = null;
        this.namaBerkas = '';
        this.toast.success('Bukti terkirim. Menunggu verifikasi bendahara.');
        await this.muat();
      } catch (e) {
        this.toast.error(e?.response?.data?.message || 'Gagal mengirim bukti.');
      } finally {
        this.mengunggah = false;
      }
    },

    async putuskan(status) {
      const setuju = status === 'paid';

      /*
       * Server mewajibkan alasan untuk penolakan. Dulu tombol ini tidak
       * mengirimkannya sama sekali, jadi setiap penolakan dari halaman ini
       * berakhir dengan "Gagal memproses".
       */
      if (!setuju && !this.alasanTolak) {
        this.toast.warning('Tulis alasan penolakan dulu, supaya pelatih tahu apa yang harus diperbaiki.');
        this.$refs.alasanTolak?.focus();
        return;
      }

      const ok = await this.konfirmasi({
        title: setuju ? 'Setujui pembayaran?' : 'Tolak pembayaran?',
        message: setuju
          ? `Seluruh ${this.rincian.length} atlet pada tagihan ${this.tagihan.invoice_number} akan berstatus lunas.`
          : `Tagihan ${this.tagihan.invoice_number} akan ditandai ditolak dan pelatih diminta mengirim ulang bukti.`,
        confirmText: setuju ? 'Ya, tandai lunas' : 'Ya, tolak',
        tone: setuju ? 'default' : 'danger',
      });

      if (!ok) return;

      this.memproses = true;
      try {
        await http.post(`/billings/${this.tagihan.id}/confirm-payment`, {
          status,
          reject_reason: setuju ? null : this.alasanTolak,
        });
        this.alasanTolak = '';
        this.toast.success(setuju ? 'Pembayaran disetujui.' : 'Pembayaran ditolak.');
        await this.muat();
      } catch (e) {
        this.toast.error(e?.response?.data?.message || 'Gagal memproses.');
      } finally {
        this.memproses = false;
      }
    },

    async unduhInvoice() {
      if (!this.tagihan?.id) return;
      this.mengunduhInvoice = true;
      try {
        const response = await http.get(`/billings/${this.tagihan.id}/invoice-pdf?t=${Date.now()}`, {
          responseType: 'blob',
        });
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = `Invoice-${this.tagihan.invoice_number || this.tagihan.id}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(link.href);
        this.toast.success('Invoice berhasil diunduh.');
      } catch (error) {
        console.error('Error downloading invoice:', error);
        this.toast.error('Gagal mengunduh invoice.');
      } finally {
        this.mengunduhInvoice = false;
      }
    },

    async unduhKwitansi() {
      if (!this.tagihan?.id) return;
      this.mengunduhKwitansi = true;
      try {
        const response = await http.get(`/billings/${this.tagihan.id}/kwitansi-pdf`, {
          responseType: 'blob',
        });
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = `Kwitansi-${this.tagihan.invoice_number || this.tagihan.id}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(link.href);
        this.toast.success('Kwitansi resmi berhasil diunduh.');
      } catch (error) {
        console.error('Error downloading kwitansi:', error);
        this.toast.error('Gagal mengunduh kwitansi.');
      } finally {
        this.mengunduhKwitansi = false;
      }
    },

    async hapusTagihan() {
      if (!this.tagihan?.id) return;

      const ok = await this.konfirmasi({
        title: 'Hapus Tagihan Ini?',
        message: `Tagihan ${this.tagihan.invoice_number} akan dihapus secara permanen. Atlet/tim di dalam tagihan ini akan kembali berstatus belum tertagih sehingga dapat dibuatkan tagihan baru.`,
        confirmText: 'Ya, Hapus Tagihan',
        tone: 'danger',
      });

      if (!ok) return;

      this.menghapus = true;
      try {
        await http.delete(`/billings/${this.tagihan.id}`);
        this.toast.success('Tagihan berhasil dihapus.');
        this.$router.push('/admin/payment');
      } catch (e) {
        const msg = e?.response?.data?.message || 'Gagal menghapus tagihan.';
        this.toast.error(msg);
      } finally {
        this.menghapus = false;
      }
    },
  },
};
</script>

<style scoped>
.tagihan__pesan { padding: var(--space-8); text-align: center; color: var(--text-muted); }

/* ── Kepala ── */
.tagihan__kepala {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  padding-bottom: var(--space-4);
  margin-bottom: var(--space-5);
  border-bottom: 1px solid var(--border-subtle);
}

@media (min-width: 640px) {
  .tagihan__kepala { flex-direction: row; align-items: flex-start; justify-content: space-between; }
}

.tagihan__nomor {
  font-size: var(--text-xs);
  font-weight: 700;
  letter-spacing: 0.08em;
  color: var(--text-muted);
}

.tagihan__judul {
  margin: 4px 0 0;
  font-family: var(--font-display);
  font-size: var(--text-xl);
  font-weight: 800;
  color: var(--text-primary);
  overflow-wrap: anywhere;
}

.lencana {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  padding: var(--space-1) var(--space-3);
  font-size: var(--text-xs);
  font-weight: 700;
  white-space: nowrap;
  border-radius: var(--radius-full);
  align-self: flex-start;
}

.lencana--hijau  { color: var(--success-600); background: rgb(22 163 74 / 0.12); }
.lencana--kuning { color: var(--text-brand);  background: var(--accent-subtle); }
.lencana--biru   { color: #2563EB;            background: rgb(37 99 235 / 0.12); }
.lencana--merah  { color: var(--danger-600);  background: rgb(220 38 38 / 0.12); }
.lencana--netral { color: var(--text-muted);  background: var(--bg-sunken); }

/* ── Langkah ── */
.langkah {
  list-style: none;
  display: grid;
  gap: var(--space-2);
  margin: 0 0 var(--space-6);
  padding: 0;
}

@media (min-width: 768px) { .langkah { grid-template-columns: repeat(4, 1fr); } }

.langkah__butir {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  padding: var(--space-2) var(--space-3);
  background: var(--bg-sunken);
  border-radius: var(--radius-md);
  font-size: var(--text-xs);
  color: var(--text-muted);
}

.langkah__butir--lewat { color: var(--text-primary); background: var(--accent-subtle); }

.langkah__angka {
  display: grid;
  place-items: center;
  width: 20px; height: 20px;
  font-weight: 800;
  font-size: 0.65rem;
  color: var(--text-muted);
  background: var(--bg-surface);
  border-radius: 50%;
  flex-shrink: 0;
}

.langkah__butir--lewat .langkah__angka { color: #fff; background: var(--accent); }

/* ── Isi ── */
.tagihan__isi { display: grid; gap: var(--space-5); }
@media (min-width: 992px) { .tagihan__isi { grid-template-columns: 1fr 1fr; align-items: start; } }

.tagihan__blok {
  padding: var(--space-4);
  background: var(--bg-sunken);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-lg);
}

.tagihan__blok--panitia { margin-top: var(--space-5); border-color: var(--accent); }

.tagihan__subjudul {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  margin: 0 0 var(--space-3);
  font-size: var(--text-sm);
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--text-muted);
}

.tagihan__subjudul--kecil { margin-top: var(--space-5); }

.tagihan__hitung {
  padding: 1px 8px;
  font-size: var(--text-xs);
  color: var(--text-secondary);
  background: var(--bg-surface);
  border-radius: var(--radius-full);
}

/* ── Rincian ── */
.rincian { list-style: none; margin: 0; padding: 0; }

.rincian__baris {
  display: flex;
  justify-content: space-between;
  gap: var(--space-3);
  padding: var(--space-2) 0;
  font-size: var(--text-sm);
  border-bottom: 1px dashed var(--border-subtle);
}

.rincian__nama { color: var(--text-primary); overflow-wrap: anywhere; }
.rincian__biaya { color: var(--text-secondary); white-space: nowrap; }

.rincian__total {
  display: flex;
  justify-content: space-between;
  padding-top: var(--space-3);
  margin-top: var(--space-2);
  font-size: var(--text-base);
  color: var(--text-primary);
  border-top: 2px solid var(--border-strong);
}

.rincian__total strong { font-family: var(--font-display); font-size: var(--text-lg); }

/* ── Rekening ── */
.rekening { display: grid; gap: var(--space-3); }

.rekening__baris { display: flex; flex-direction: column; gap: 2px; }
.rekening__baris small {
  font-size: var(--text-xs);
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--text-muted);
}
.rekening__baris span { font-size: var(--text-sm); font-weight: 600; color: var(--text-primary); }

.rekening__nomor { display: flex; align-items: center; gap: var(--space-3); flex-wrap: wrap; }

.rekening__salin {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px var(--space-2);
  font-size: var(--text-xs);
  font-weight: 600;
  color: var(--text-brand);
  background: var(--accent-subtle);
  border: none;
  border-radius: var(--radius-sm);
  cursor: pointer;
}

/* ── Bukti ── */
.bukti__gambar {
  width: 100%;
  max-width: 260px;
  border-radius: var(--radius-md);
  border: 1px solid var(--border-subtle);
  margin-bottom: var(--space-3);
}

.bukti__pilih {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  min-height: 44px;
  padding: var(--space-2) var(--space-4);
  font-size: var(--text-sm);
  font-weight: 600;
  color: var(--text-secondary);
  background: var(--bg-surface);
  border: 1px dashed var(--border-strong);
  border-radius: var(--radius-md);
  cursor: pointer;
}

.bukti__input { display: none; }
.bukti__nama { margin: var(--space-2) 0 0; font-size: var(--text-xs); color: var(--text-muted); }
.bukti__kirim { margin-top: var(--space-3); width: 100%; justify-content: center; }

.bukti__keterangan,
.tagihan__catatan,
.tagihan__lunas {
  display: flex;
  align-items: flex-start;
  gap: var(--space-2);
  margin-top: var(--space-3);
  padding: var(--space-3);
  font-size: var(--text-xs);
  line-height: 1.6;
  color: var(--text-secondary);
  background: var(--bg-surface);
  border-radius: var(--radius-md);
}

.tagihan__lunas { color: var(--success-600); }
.tagihan__catatan i { color: var(--accent); }
.tagihan__catatan-kecil { font-size: var(--text-xs); color: var(--text-muted); margin-bottom: var(--space-3); }

.tagihan__aksi { display: flex; flex-wrap: wrap; gap: var(--space-3); }
.tagihan__alasan { margin-bottom: var(--space-3); }

.tagihan__logo-event {
  width: 52px;
  height: 52px;
  object-fit: contain;
  background: var(--bg-surface, #ffffff);
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 8px;
  padding: 4px;
  flex-shrink: 0;
}

.berputar { animation: putar 900ms linear infinite; }
@keyframes putar { to { transform: rotate(360deg); } }
@media (prefers-reduced-motion: reduce) { .berputar { animation: none; } }
</style>
